import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['menPercentage', 'womenPercentage'];

    connect() {
        this.menInput = this.menPercentageTarget.firstElementChild;
        this.womenInput = this.womenPercentageTarget.firstElementChild;

        this.isUpdating = false;

        this.menInput.addEventListener('input', () => this.onMenInput());
        this.womenInput.addEventListener('input', () => this.onWomenInput());
    }

    onMenInput() {
        if (this.isUpdating) return;

        const men = parseFloat(this.menInput.value);
        if (Number.isNaN(men)) return;

        this.isUpdating = true;

        this.womenInput.value = Math.max(0, 100 - men);
        this.womenInput.dispatchEvent(new Event('change', { bubbles: true }));

        this.isUpdating = false;
    }

    onWomenInput() {
        if (this.isUpdating) return;

        const women = parseFloat(this.womenInput.value);
        if (Number.isNaN(women)) return;

        this.isUpdating = true;

        this.menInput.value = Math.max(0, 100 - women);
        this.menInput.dispatchEvent(new Event('change', { bubbles: true }));

        this.isUpdating = false;
    }
}
